import React from "react";
import { Stack } from "@mantine/core";
import type { MantineSpacing } from "@mantine/core";
import styles from "./SettingsPageLayout.module.css";

export interface SettingsPageLayoutProps {
  /** Page header — typically a <SettingsPageHeader />. */
  header?: React.ReactNode;
  /** Page body. */
  children: React.ReactNode;
  /** Space between the header and the body. Defaults to "lg". */
  gap?: MantineSpacing;
  /** Escape hatch for one-off layout tweaks. */
  className?: string;
}

/**
 * Standard container for a Settings page: one consistent padding + vertical
 * rhythm, so pages stop each re-declaring `Stack p="md" | "lg"`. Compose it
 * with a <SettingsPageHeader /> in the `header` slot; page content goes in
 * `children`.
 */
export default function SettingsPageLayout({
  header,
  children,
  gap = "lg",
  className,
}: SettingsPageLayoutProps) {
  return (
    <Stack
      gap={gap}
      className={[styles.page, className].filter(Boolean).join(" ")}
    >
      {header}
      {children}
    </Stack>
  );
}
